import styled from "styled-components/native";
import { View } from "react-native";
import { Theme } from "../../../../theming/types";
import { PageHeight } from "../../context/types";

export const StyledView = styled(View)<PageHeight>`
  background-color: ${(props: { theme: Theme }) =>
    props.theme.colors.white[900]};
  width: 100%;
  height: ${({ isFlexible, pageHeight }: PageHeight) =>
    isFlexible ? pageHeight : "100%"};
  top: 0;
  left: 0;
`;
